export const SITE_ORIGIN = "https://zubilo.studio";

export const SITE = {
  brand: "Zubilo Apparels",
  siteNameShort: "ZUBILO",
  origin: SITE_ORIGIN,
  defaultOgImage: `${SITE_ORIGIN}/slider/slide-1.jpg`,
  logo: `${SITE_ORIGIN}/logo192.png`,
  language: "en",
  country: "WORLD",
  areaServed: "Worldwide",
  // These are safe defaults; you can later wire these to /site-settings.
  contactEmail: "rkgarmentsmeesho@gmail.com",
  contactPhone: "+918053317489",
  contactAddress: "West Kasa, United States",
  socials: {
    instagram: "",
    facebook: "",
    twitter: "",
    youtube: "",
  },
};
